import React, { useState } from 'react';

//Material
import { Box, Collapse, Grid, IconButton, Typography } from '@mui/material';
//Material icons
import ArrowDropDownOutlinedIcon from '@mui/icons-material/ArrowDropDownOutlined';
import ArrowDropUpOutlinedIcon from '@mui/icons-material/ArrowDropUpOutlined';

import { connect, useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setIsOpenCalendarModal } from '../../../redux/mainReducer';

const DraggableItem = ({ event, index, open, setOpen, calendarFunc }) => {
  const navigate = useNavigate();
  const language = useSelector((state) => state.Intl.locale);
  const dispatch = useDispatch();

  return (
    <Box
      data-event={`{"id": "${event.id}","service": "${
        event?.service ? event.service : ''
      }","title": "${event.title}","paymentType": "${event.paymentType}","deliveryType": "${
        event.deliveryType
      }","comment": "${event.comment}","contacts": "${event.contacts}",
        "color": "${event.color}","startHour": "${event.startHour}","endHour": "${
        event.endHour
      }","date": "${event.date}","createdAt": "${event.createdAt}","createdBy": "${
        event.createdBy
      }","qty": "${event.qty}","serviceID": "${event.serviceID}"}`}
      id="dragItem"
      className="draggableWrapper"
      sx={{
        display: 'flex',
        alignItems: 'start',
        boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)',
        background: '#FFF',
        padding: '0px 10px',
        marginBottom: '2px',
        borderRadius: '8px',
        cursor: 'pointer'
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'start', height: '100%' }}>
        {/*<DragIndicatorIcon sx={{ color: 'black', fontSize: '30px', mt: 2.8, mb: 2.8 }} />*/}
        <Typography sx={{ fontSize: '16px', mr: 2.1, mt: 0.5, mb: 2.8 }}>{event.title}</Typography>
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'column', mt: 1, mb: 1, width: '100%' }}>
        <Typography
          onClick={() => navigate(`/${language}/service/${event.serviceID}`)}
          sx={{
            fontFamily: 'FixelText-Regular',
            fontSize: { xs: '14px', sm: '16px' },
            cursor: 'pointer',
            width: 'fit-content',
            mr: 1.1,
            display: 'flex'
          }}
        >
          {event?.service && event?.service.length !== 0 ? event.service : ''}
          <Typography
            sx={{
              fontFamily: 'FixelText-Regular',
              fontSize: { xs: '14px', sm: '16px' },
              cursor: 'pointer',
              width: 'fit-content',
              ml: 1.1,
              color: '#7b7b7b'
            }}
          >
            {event?.qty} од.
          </Typography>
        </Typography>
        <Box id={`openMenu${index}`} sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
          <Typography
            sx={{
              fontFamily: 'FixelText-Regular',
              color: '#60A5DF',
              fontSize: '14px',
              cursor: 'pointer',
              width: 'fit-content'
            }}
            onClick={() => setOpen(!open)}
          >
            {open ? 'Згорнути деталі' : 'Деталі замовлення'}
          </Typography>
          <IconButton
            disableRipple
            disableFocusRipple
            aria-label="expand row"
            size="small"
            sx={{
              color: '#60A5DF',
              ':hover': {
                backgroundColor: 'unset !important'
              }
            }}
            onClick={() => setOpen(!open)}
          >
            {open ? <ArrowDropUpOutlinedIcon /> : <ArrowDropDownOutlinedIcon />}
          </IconButton>
          <Typography
            sx={{
              fontFamily: 'FixelText-Regular',
              color: '#60A5DF',
              fontSize: '14px',
              cursor: 'pointer',
              width: 'fit-content',
              ml: 'auto'
            }}
            onClick={() =>
              dispatch(
                setIsOpenCalendarModal({
                  isOpen: true,
                  func: calendarFunc,
                  id: event.id,
                  startDate: event?.date
                })
              )
            }
          >
            {event?.date?.split('-')?.reverse()?.join('.')}
          </Typography>
          <IconButton
            disableRipple
            disableFocusRipple
            aria-label="expand row"
            size="small"
            sx={{
              color: '#60A5DF',
              ':hover': {
                backgroundColor: 'unset !important'
              }
            }}
            onClick={() =>
              dispatch(setIsOpenCalendarModal({ isOpen: true, func: calendarFunc, id: event.id }))
            }
          >
            {open ? <ArrowDropUpOutlinedIcon /> : <ArrowDropDownOutlinedIcon />}
          </IconButton>
        </Box>
        <Collapse in={open} timeout="auto" unmountOnExit>
          <Grid container>
            <Grid
              item
              xs={12}
              sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'start' }}
            >
              {/*<Typography sx={{ fontSize: '14px', fontWeight: '600' }}>Про замовлення:</Typography>*/}
              {/*<Typography sx={{ fontSize: '14px' }}>{`${*/}
              {/*  event?.service && event.service.length !== 0 ? event?.service : ''*/}
              {/*}, ${event?.qty} од.`}</Typography>*/}
              <Typography
                sx={{
                  fontSize: '12px',
                  fontWeight: '500',
                  fontFamily: 'FixelText-Medium !important'
                }}
              >
                Контактні дані:
              </Typography>
              <Typography sx={{ fontSize: '12px', fontFamily: 'FixelText-Regular !important' }}>
                {event.contacts}
              </Typography>
              <Typography
                sx={{
                  fontSize: '12px',
                  fontWeight: '500',
                  fontFamily: 'FixelText-Medium !important'
                }}
              >
                Спосіб доставки:
              </Typography>
              <Typography sx={{ fontSize: '12px', fontFamily: 'FixelText-Regular !important' }}>
                {event.deliveryType}
              </Typography>
              <Typography
                sx={{
                  fontSize: '12px',
                  fontWeight: '500',
                  fontFamily: 'FixelText-Medium !important'
                }}
              >
                Спосіб оплати:
              </Typography>
              <Typography sx={{ fontSize: '12px', fontFamily: 'FixelText-Regular !important' }}>
                {event.paymentType}
              </Typography>
              {event?.comment.length !== 0 && (
                <>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '500',
                      fontFamily: 'FixelText-Medium !important'
                    }}
                  >
                    Коментар до замовлення:
                  </Typography>
                  <Typography sx={{ fontSize: '12px', fontFamily: 'FixelText-Regular !important' }}>
                    {event?.comment}
                  </Typography>
                </>
              )}
            </Grid>
          </Grid>
        </Collapse>
      </Box>
    </Box>
  );
};

function OrderDraggable({ dataSetter, event, index, calendarFunc }) {
  const [open, setOpen] = useState(false);

  return (
    <DraggableItem
      event={event}
      index={index}
      open={open}
      setOpen={setOpen}
      calendarFunc={calendarFunc}
    />
  );
}
const mapStateToProps = (state) => {
  return {
    language: state.Intl.locale,
    userData: state.global.userData
  };
};
export default connect(mapStateToProps)(OrderDraggable);
